import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import map from 'lodash/map';
import get from 'lodash/get';
import has from 'lodash/has';
import moment from 'moment';
import unionBy from 'lodash/unionBy';
import isEmpty from 'lodash/isEmpty';
import './ExportToCsv.css';

function getKeyValue(key, object) {
  return object.metrics[key] instanceof Array && typeof object.metrics[key] !== undefined ? object.metrics[key].length : 0;
};

class ExportToCSV extends Component {

  getCreatedByName = (item, isAnonymous) => {
      if(isAnonymous) {
        return 'Anonymous';
      }
      else if(!isEmpty(item.firstName) || !isEmpty(item.lastName) && item["firstName"] !== undefined && item["lastName"] !== undefined) {
          return `${item.firstName} ${item.lastName}`
      }
      return 'NA';
  }

  getStoryStatus = (item) => {

    return item.isDeleted ? `Archived ` : item.privacy === 'REMOVED' ? 'Removed from feed' : 'Active';
  }

  createTextValue=(val)=>{
    let temp= document.createElement('p');
    temp.innerHTML= val;
    let text= temp.textContent || temp.innerText;
    temp=null;
    return text;
  //  let text=  val.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "")
  //             .replace (/(^")|("$)/g, '')
  //             .replace(/^[ ]+|[ ]+$/g,'')
  //             .replace(/\s+/g, ' ')
  //             .replace(/,/g, "")
  //   return text
  }

  getData = (data) => {
    const { Analytics } = this.props;
    const csvData = [];
    map(data, (d) => {
      // console.log(d)
      let eachUserRow = {
        name: this.createTextValue(d.description), 
        createdDate: moment(d.createdOn).format('MM/DD/YYYY'),
        createdBy: this.getCreatedByName(d.userId, d.isAnonymous),
        storyStatus : this.getStoryStatus(d)
      }
      csvData.push(eachUserRow);
    });
    return csvData;
  }

  render() {
    const ChartStaticHeaders = [
      { label: "Story Title", key: "name" },
      { label: "Date Created", key: "createdDate" },
      { label: "Created By", key: "createdBy" },
      { label: "Story Status", key: "storyStatus" },
    ];
    const { Analytics } = this.props;
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 tool-list-font text-right">
        <span className="linkclass" style={{ lineHeight: '42px' }}><i className="flaticon-export" style={{ marginRight: '8px' }}></i>
          <CSVLink
            data={this.getData(Analytics)}
            headers={ChartStaticHeaders}
            filename={`Culture App Analytics-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
          >Export to CSV</CSVLink>
        </span>
      </div>
    )
  }
}

export default ExportToCSV;